import {
  encodeURLParameter1u3y18ab0iker as encodeURLParameter,
  decodeURLQueryComponent1psnpw5x5jp3h as decodeURLQueryComponent,
  encodeURLParameterValueqlj48e6qtqd4 as encodeURLParameterValue,
} from './Codecs.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { toSet2orjxp16sotqu as toSet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { ParametersBuilder1ry9ntvvg567r as ParametersBuilder } from './Parameters.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var UrlDecodedParametersBuilderClass;
function UrlDecodedParametersBuilder() {
  if (UrlDecodedParametersBuilderClass === VOID) {
    class $ {
      constructor(encodedParametersBuilder) {
        this.u5a_1 = encodedParametersBuilder;
        this.v5a_1 = this.u5a_1.r4s();
      }
      e3a() {
        return decodeParameters(this.u5a_1);
      }
      r4s() {
        return this.v5a_1;
      }
      s4s(name) {
        var tmp0_safe_receiver = this.u5a_1.s4s(encodeURLParameter(name));
        var tmp;
        if (tmp0_safe_receiver == null) {
          tmp = null;
        } else {
          // Inline function 'kotlin.collections.map' call
          // Inline function 'kotlin.collections.mapTo' call
          var destination = ArrayList().i2(collectionSizeOrDefault(tmp0_safe_receiver, 10));
          var _iterator__ex2g4s = tmp0_safe_receiver.p1();
          while (_iterator__ex2g4s.q1()) {
            var item = _iterator__ex2g4s.r1();
            var tmp$ret$2 = decodeURLQueryComponent(item, VOID, VOID, true);
            destination.j2(tmp$ret$2);
          }
          tmp = destination;
        }
        return tmp;
      }
      m4r(name) {
        return this.u5a_1.m4r(encodeURLParameter(name));
      }
      t4s() {
        // Inline function 'kotlin.collections.map' call
        var this_0 = this.u5a_1.t4s();
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().i2(collectionSizeOrDefault(this_0, 10));
        var _iterator__ex2g4s = this_0.p1();
        while (_iterator__ex2g4s.q1()) {
          var item = _iterator__ex2g4s.r1();
          var tmp$ret$2 = decodeURLQueryComponent(item);
          destination.j2(tmp$ret$2);
        }
        return toSet(destination);
      }
      n1() {
        return this.u5a_1.n1();
      }
      m4s() {
        return decodeParameters(this.u5a_1).m4s();
      }
      w4s(name, value) {
        return this.u5a_1.w4s(encodeURLParameter(name), encodeURLParameterValue(value));
      }
      x4s(stringValues) {
        return appendAllEncoded(this.u5a_1, stringValues);
      }
      n4s(name, values) {
        var tmp = encodeURLParameter(name);
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().i2(collectionSizeOrDefault(values, 10));
        var _iterator__ex2g4s = values.p1();
        while (_iterator__ex2g4s.q1()) {
          var item = _iterator__ex2g4s.r1();
          var tmp$ret$2 = encodeURLParameterValue(item);
          destination.j2(tmp$ret$2);
        }
        return this.u5a_1.n4s(tmp, destination);
      }
      y4() {
        return this.u5a_1.y4();
      }
    }
    initMetadataForClass($, 'UrlDecodedParametersBuilder');
    UrlDecodedParametersBuilderClass = $;
  }
  return UrlDecodedParametersBuilderClass;
}
function encodeParameters(parameters) {
  // Inline function 'kotlin.apply' call
  var this_0 = ParametersBuilder();
  appendAllEncoded(this_0, parameters);
  return this_0;
}
function decodeParameters(parameters) {
  // Inline function 'kotlin.apply' call
  var this_0 = ParametersBuilder();
  appendAllDecoded(this_0, parameters);
  return this_0.e3a();
}
function appendAllEncoded(_this__u8e3s4, parameters) {
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = parameters.t4s().p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp0_elvis_lhs = parameters.s4s(element);
    var values = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
    var tmp = encodeURLParameter(element);
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().i2(collectionSizeOrDefault(values, 10));
    var _iterator__ex2g4s_0 = values.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var item = _iterator__ex2g4s_0.r1();
      var tmp$ret$4 = encodeURLParameterValue(item);
      destination.j2(tmp$ret$4);
    }
    _this__u8e3s4.n4s(tmp, destination);
  }
}
function appendAllDecoded(_this__u8e3s4, parameters) {
  // Inline function 'kotlin.collections.forEach' call
  var _iterator__ex2g4s = parameters.t4s().p1();
  while (_iterator__ex2g4s.q1()) {
    var element = _iterator__ex2g4s.r1();
    var tmp0_elvis_lhs = parameters.s4s(element);
    var values = tmp0_elvis_lhs == null ? emptyList() : tmp0_elvis_lhs;
    var tmp = decodeURLQueryComponent(element);
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList().i2(collectionSizeOrDefault(values, 10));
    var _iterator__ex2g4s_0 = values.p1();
    while (_iterator__ex2g4s_0.q1()) {
      var item = _iterator__ex2g4s_0.r1();
      var tmp$ret$4 = decodeURLQueryComponent(item, VOID, VOID, true);
      destination.j2(tmp$ret$4);
    }
    _this__u8e3s4.n4s(tmp, destination);
  }
}
//region block: exports
export {
  UrlDecodedParametersBuilder as UrlDecodedParametersBuilder18hwlye3pykgz,
  encodeParameters as encodeParameters1kx5voquz3xxo,
};
//endregion

//# sourceMappingURL=UrlDecodedParametersBuilder.mjs.map
